import React from 'react';
import { Stack, Typography, CircularProgress } from '@mui/material';

export default function Loader({ sx }) {
  return (
    <Stack
      sx={{
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        flex: 1,
        ...sx,
      }}
    >
      <CircularProgress />
      <Typography color="primary.main">Loading...</Typography>
    </Stack>
  );
}
